// Bundled Arase QR encoder (see vendor/raffle-qrcode and its license).
// Neither guest URL nor any participant data is sent to third-party services.
import QRCode from '../vendor/raffle-qrcode';
import Level from '../vendor/raffle-qrcode/QRErrorCorrectLevel';

export function raffleEntryUrl(id, origin = window.location.origin) {
  if (!/^[1-9]\d*$/.test(String(id))) throw new Error('Invalid raffle ID');
  const base = new URL(origin);
  if (!/^https?:$/.test(base.protocol)) throw new Error('Invalid entry origin');
  return new URL(`/raffles/${id}`, base).href;
}

// SVG with four-module quiet zone; works in print and on disconnected displays.
export function qrSvg(url) {
  const qr = new QRCode(0, Level.M);
  qr.addData(url);
  qr.make();
  const size = qr.getModuleCount();
  let path = '';
  for (let y = 0; y < size; y++) {
    for (let x = 0; x < size; x++) {
      if (qr.isDark(y, x)) path += `M${x + 4} ${y + 4}h1v1h-1z`;
    }
  }
  const width = size + 8;
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${width}" role="img" aria-label="Entry QR code" shape-rendering="crispEdges"><rect width="${width}" height="${width}" fill="#fff"/><path fill="#111" d="${path}"/></svg>`;
}

export function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, char => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  })[char]);
}
